import {
  transformCourses,
  transformStudentCourseDetails,
  transformStudentCourseSections,
  transformStudentCourses
} from './transform';

export default {
  getCourses: {
    name: 'learnWorldsCourses',
    path: 'learnwords/courses',
    transform: transformCourses,
    defaultValue: [],
    memoize: false
  },
  getStudentCourses: {
    name: 'studentCourseProgress',
    path: 'learnwords/students/courses',
    transform: transformStudentCourses,
    defaultValue: { data: [], total: 0 },
    memoize: false
  },
  getStudentCourseDetails: {
    name: 'studentCourseDetails',
    path: 'learnwords/students/:studentId/courses',
    transform: transformStudentCourseDetails,
    defaultValue: [],
    memoize: false
  },
  getStudentCourseSections: {
    name: 'studentCourseSections',
    path: 'learnwords/students/:studentId/courses/:courseId/sections',
    transform: transformStudentCourseSections,
    defaultValue: [],
    memoize: false
  },
  downloadAll: {
    path: 'learnwords/students/courses/reports/zip'
  },
  downloadStudent: {
    path: 'learnwords/students/:studentId/courses/:courseId/report'
  }
};
